export function OnlineIndicator() {
  return (
    <div className="border-cold-800 bg-cardgreen-500 size-4 min-h-4 min-w-4 rounded-full border-2" />
  );
}
